import FullCalendar from "@fullcalendar/react"
import { MutableRefObject } from "react"
import { GrNext, GrPrevious } from "react-icons/gr"
import { useTranslation } from "react-i18next"
import { GoToPrevWrapper } from "./styles"
import { useRecoilState } from "recoil"
import { NewCalenderPageCount } from "@store/index"

interface IProps {
	calendarRef: MutableRefObject<FullCalendar | null>
}
export default function GoToPrev({ calendarRef }: IProps) {
	const [pageCount, setPageCount] = useRecoilState(NewCalenderPageCount)
	const { i18n } = useTranslation()
	const isRTL = i18n.language === 'ar'

	const goToPrev = () => {
		const calendarApi = calendarRef.current?.getApi()
		if (calendarApi) {
			calendarApi.prev() // Navigate to the next period
			setPageCount(pageCount - 1)
		}
	}
	return (
		<GoToPrevWrapper>
			<button  onClick={goToPrev}>
				{isRTL ? <GrNext /> : <GrPrevious />}
			</button>
		</GoToPrevWrapper>
	)
}
